export default __webpack_public_path__ + "static/media/powerSupply.5dffd52b.svg";